import copyToClipboard from 'copy-text-to-clipboard'
import { Injectable } from '@angular/core'
import { NotifyService } from './notify.service'
import { SocketService } from './socket.service'

@Injectable({ providedIn: 'root' })
export class DatabaseProfilerService {
  constructor (
    socket: SocketService,
    notify: NotifyService,
  ) {
    socket.subject('debug:slow-query').subscribe(data => {
      let html = '<table>'
      let text = 'Tables:\n\n'
      for (const item of data.explained) {
        html += `<tr>
          <tr>
            <th>Table</th>
            <td><code>${item.table}</code></td>
          </tr>
          <tr>
            <th>Type</th>
            <td><code>${item.type}</code></td>
          </tr>
          <tr>
            <th>Flags</th>
            <td>${item.flags}</td>
          </tr>
        </tr>`
        text += `* \`${item.table}\` \`${item.type}\` \`${item.flags}\`\n`
      }
      html += `</table><hr><code>${data.sql}</code>`
      text += `\nSQL:\n\`\`\`\n${data.sql}\n\`\`\`\n`
      text += `Traceback:\n\`\`\`\n${data.traceback}\n\`\`\`\n`
      notify.custom(
        'warning',
        'Slow query',
        html,
        {
          markup: true,
          click: () => {
            copyToClipboard(text)
            notify.success('Copied to clipboard')
          },
        },
      )
    })
  }
}
